import Vue from 'vue'
import VueRouter from 'vue-router'

// 重写push方法，不然当路由跳转到当前路由会报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const _import_ = file => () => import('../views/' + file + '.vue')

const routes = [
  {
    path: '',
    name: 'layout',
    component: _import_('layout'),
    children: [
      {
        path: '/',
        name: 'home',
        component: _import_('home/index'),
        meta: {
          title: '首页',
          loginNoRequired: false,
          breadList: []
        }
      },
      {
        path: '/competition_detail',
        name: 'competition_detail',
        component: _import_('home/competitionDetail'),
        meta: {
          title: '比赛详情',
          loginNoRequired: false,
          breadList: []
        }
      },
      {
        path: '/competition_result',
        name: 'competition_result',
        component: _import_('competition/competitionResult'),
        meta: {
          title: '比赛结果',
          breadList: []
        }
      },
      {
        path: '/my_competition',
        name: 'my_competition',
        component: _import_('home/myCompetition'),
        meta: {
          title: '我的比赛',
          breadList: []
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: _import_('login/index'),
    meta: {
      loginNoRequired: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: _import_('login/register'),
    meta: {
      loginNoRequired: true
    }
  },
  {
    path: '/certification',
    name: 'certification',
    component: _import_('login/certification'),
    meta: {
      loginNoRequired: true
    }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
